// Espace copropriétaire hébergé par Vilogi (application externe).
export const VILOGI_URL = "https://copro.vilogi.com/";
